import React from 'react';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';
import { Input as FormInput } from '../Form/Input';
import { Button } from '../Button';
import { withInputClassNames } from './HOC';

const Input = withInputClassNames(FormInput);

const ResetPasswordForm = () => (
  <Form className="reset-password__form login">
    <div className="reset-password__form__header-wrapper">
      <div className="reset-password__form__form-header">Setup your new password</div>
    </div>
    <div className="reset-password__form__subtitle-wrapper">
      <div className="reset-password__form__form-subtitle">Your password must be at least 8 characters</div>
    </div>
    <div className="reset-password__form__password-input">
      <Input name="password" type="password" label="Password" />
    </div>
    <div className="reset-password__form__password-input">
      <Input name="confirm_password" type="password" label="Confirm Password" />
    </div>
    <Button
      type="submit"
      title="Set Password"
      className="reset-password__form__form-submit"
    />
  </Form>
);

export default withFormik({
  handleSubmit: (values, { props, setSubmitting }) =>
    props.onSubmit && props.onSubmit(values, setSubmitting),
  validationSchema: Yup.object().shape({
    password: Yup.string()
      .min(8, 'Password should have at least 8 characters')
      .required('Password is required'),
    confirm_password: Yup.string()
      .min(8, 'Password should have at least 8 characters')
      .oneOf([Yup.ref('password'), null], 'Passwords are not the same')
      .required('Confirm Password is required'),
  }),
  displayName: 'ResetPasswordForm',
})(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/ResetPasswordForm/ResetPasswordForm.js